/* AFIQ digital download PDP (sections/afiq-digital-main.liquid): page gallery + add-on downloads.
   Add to cart: this product plus any ticked add-ons through AFIQ_UI.addToCart (one /cart/add.js call). */
(function () {
  var root = document.querySelector('[data-adig]');
  if (!root || !window.AFIQ_UI) return;
  var U = window.AFIQ_UI;
  var form = root.querySelector('[data-adig-form]'), atc = root.querySelector('[data-adig-atc]'), label = root.querySelector('[data-adig-atc-label]');
  var self = { id: +form.querySelector('input[name="id"]').value, price: 0 };
  var addons = [].slice.call(root.querySelectorAll('[data-adig-addon]'));
  var basePrice = (function () { var b = root.querySelector('.adig-self .apdp-price b'); return b ? Math.round(parseFloat(b.textContent.replace(/[^0-9.]/g, '')) * 100) : 0; })();

  function picked() { return addons.filter(function (b) { return b.getAttribute('aria-pressed') === 'true'; }); }
  function render() {
    var on = picked(), total = basePrice + on.reduce(function (s, b) { return s + (+b.dataset.price || 0); }, 0);
    if (label && !atc.disabled) label.textContent = (on.length ? 'Add ' + (on.length + 1) + ' downloads · ' : 'Add to cart · ') + U.$(total);
  }
  addons.forEach(function (b) {
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') !== 'true';
      b.setAttribute('aria-pressed', on); b.classList.toggle('is-on', on);
      b.querySelector('.apdp-addon-box').textContent = on ? '✓' : '+';
      U.track('afiq_digital_addon', { addon: b.dataset.title, on: on });
      render();
    });
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var src = 'pdp-digital';
    var items = [{ id: self.id, quantity: 1 }].concat(picked().map(function (b) { return { id: +b.dataset.variant, quantity: 1 }; }));
    var ups = picked().map(function (b) { return 'b10x-upsell-pdp-pdf-' + (b.dataset.handle || '').replace(/-pdf$/, ''); });
    U.addToCart(items, src, atc).then(function () { if (ups.length && U.tagUpsell) return U.tagUpsell(ups); });
  });
  var x = root.querySelector('[data-adig-xsell]');
  if (x) x.addEventListener('click', function () { U.track('afiq_digital_xsell', { to: 'elite' }); });

  /* gallery */
  var track = root.querySelector('[data-adig-track]'), idx = root.querySelector('[data-adig-idx]'), thumbs = [].slice.call(root.querySelectorAll('[data-adig-thumb]'));
  if (!track) return;
  function cur() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
  function go(i) { var n = track.children.length; i = (i + n) % n; track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  root.addEventListener('click', function (e) {
    var g = e.target.closest('[data-adig-go]'); if (g) { go(cur() + (+g.dataset.adigGo)); return; }
    var t = e.target.closest('[data-adig-thumb]'); if (t) go(+t.dataset.adigThumb);
  });
  track.addEventListener('scroll', function () {
    var i = cur(); if (idx) idx.textContent = i + 1;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
  }, { passive: true });
})();
